function updateProductCount(amountAdded) {
  const counter = document.querySelector('.gdc-js-show-more-count')
  const count = parseInt(counter.textContent)

  counter.textContent = amountAdded + count
}

function hideButtonSection() {
  document.querySelector('.gdc-js-button-show-more').style.display = 'none'
}

function handleButtonVisibility(totalHidden, limit) {
  if (totalHidden < limit) hideButtonSection()
}

function handleLoadMore(e) {
  const limit = parseInt(e.target.dataset.showMoreLimit)
  const hiddenElements = document.querySelectorAll('.product-item.hide')
  const totalHidden = hiddenElements.length

  hiddenElements.forEach((elem, idx) => {
    if (idx < limit) elem.classList.remove('hide')
  })

  handleButtonVisibility(totalHidden, limit)
  updateProductCount(limit)
}
